import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const isHome = location.pathname === "/";

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/60"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-movie-2-line text-2xl" style={{ color: isScrolled || !isHome ? "oklch(var(--accent-500))" : "white" }}></i>
          </div>
          <span
            className={`text-xl font-semibold transition-colors duration-300 ${
              isScrolled || !isHome ? "text-foreground-950" : "text-white"
            }`}
          >
            丁香花影院
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          <Link
            to="/"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === "/"
                ? isScrolled || !isHome
                  ? "bg-accent-100 text-accent-900"
                  : "bg-white/20 text-white"
                : isScrolled || !isHome
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  : "text-white/80 hover:text-white hover:bg-white/10"
            }`}
          >
            首页
          </Link>
          {categories.slice(0, 5).map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                location.pathname === `/category/${cat.slug}`
                  ? "bg-accent-100 text-accent-900"
                  : isScrolled || !isHome
                    ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                    : "text-white/80 hover:text-white hover:bg-white/10"
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
              location.pathname === "/about"
                ? "bg-accent-100 text-accent-900"
                : isScrolled || !isHome
                  ? "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  : "text-white/80 hover:text-white hover:bg-white/10"
            }`}
          >
            关于我们
          </Link>
        </div>

        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg"
          aria-label="菜单"
        >
          <i
            className={`ri-menu-line text-2xl transition-colors duration-300 ${
              isScrolled || !isHome ? "text-foreground-950" : "text-white"
            }`}
          ></i>
        </button>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-3">
          <div className="flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap ${
                location.pathname === "/" ? "bg-accent-100 text-accent-900" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? "bg-accent-100 text-accent-900"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap ${
                location.pathname === "/about" ? "bg-accent-100 text-accent-900" : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}